import React from 'react';
import CategoryLandingPage from './CategoryLandingPage';
import { brunchConfig } from '../configs/categoryLandings';

export default function BrunchLandingPage() {
  return <CategoryLandingPage config={brunchConfig} />;
}
